import { sarvahAxios } from "./apiConfig";

// sarvah dashboard
export const getSarvahDetails = (path, payload) => {
  return sarvahAxios.post(path, payload);
};
